import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import InventoryLocationSelector from './InventoryLocationSelector/InventoryLocationSelector'
import * as Styles from './styles'

const InventorySection = ({ inventoryLocations, value, onChange, usedInventoryLocationIds }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Divider />
      <Text type="titleS">{t('Inventario')}</Text>
      <Text type="bodyMRegular">
        {t('Elige una ubicación de tu tienda online para sincronizar automáticamente el inventario disponible.')}
      </Text>
      <InventoryLocationSelector
        inventoryLocations={inventoryLocations}
        value={value}
        onChange={onChange}
        usedInventoryLocationIds={usedInventoryLocationIds}
      />
    </Styles.Container>
  )
}

export default InventorySection
